'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@svs/nova-core/nextjs/auth';
import { createCoupon } from '@svs/nova-poolbetting/core/action/coupon';
import { useCouponId, useCouponIndices, useCouponType } from '@svs/nova-poolbetting/core/nextjs/coupon';
import { useEngine } from '@svs/nova-poolbetting/core/nextjs/engine';
import { AddCoupons } from '@svs/nova-poolbetting/ui/Coupon';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { type ReactNode } from 'react';
type AddCouponsContainerProps = {
  size?: React.ComponentProps<typeof AddCoupons>['size'];
  onClick?: React.ComponentProps<typeof AddCoupons>['onClick'];
};

/**
 * Component to render multi coupons.
 *
 * @param root0 props
 * @param root0.size The size of the button, either 'sm' or 'md'
 * @param root0.onClick Optional onClick handler for tracking clicks on the add coupons button
 * @returns React element for multicoupon
 */
export default function AddCouponsContainer(t0) {
  const $ = _c(19);
  const {
    size,
    onClick
  } = t0;
  const [couponId, couponIndex] = useCouponId();
  const definition = useEngine();
  const {
    maxNumberOfCoupons
  } = definition;
  const {
    user
  } = useAuth();
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const couponIndices = useCouponIndices(t1);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  let t2;
  if ($[2] !== couponId || $[3] !== couponIndex) {
    t2 = {
      couponId,
      couponIndex
    };
    $[2] = couponId;
    $[3] = couponIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const couponType = useCouponType(t2);
  if (couponType !== "singlerows" && user && user.role !== "Player" && user.role !== "Unknown") {
    return;
  }
  let t3;
  if ($[5] !== couponId || $[6] !== couponType || $[7] !== pathname || $[8] !== router || $[9] !== searchParams) {
    t3 = event => {
      event.preventDefault();
      (async () => {
        const response = await createCoupon(couponType, {
          couponId
        });
        if (response.status === "ERROR") {
          return;
        }
        const qs = new URLSearchParams(searchParams.toString());
        qs.set("coupon", response.data.couponIndex.toString());
        const newUrl = `${pathname}?${qs.toString()}`;
        router.replace(newUrl, {
          scroll: false
        });
      })();
    };
    $[5] = couponId;
    $[6] = couponType;
    $[7] = pathname;
    $[8] = router;
    $[9] = searchParams;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleSubmit = t3;
  let t4;
  if ($[11] !== couponIndices || $[12] !== maxNumberOfCoupons || $[13] !== onClick || $[14] !== size) {
    t4 = <AddCoupons couponIndices={couponIndices} maxNumberOfCoupons={maxNumberOfCoupons} size={size} onClick={onClick} />;
    $[11] = couponIndices;
    $[12] = maxNumberOfCoupons;
    $[13] = onClick;
    $[14] = size;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== handleSubmit || $[17] !== t4) {
    t5 = <form onSubmit={handleSubmit}>{t4}</form>;
    $[16] = handleSubmit;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}